import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/gua";

export default function Masthead() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="fixed inset-x-0 top-0 z-50">
      {/* 顶置雷达快讯带 */}
      <div className="border-b border-background-200/70 bg-foreground-950 text-background-50">
        <div className="mx-auto flex max-w-6xl flex-col items-start gap-1 px-4 py-2 sm:flex-row sm:items-center sm:justify-between md:px-6">
          <p className="flex items-center gap-2 text-xs tracking-wide">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-radar-line text-accent-400" />
            </span>
            <span className="text-background-200">避雷雷达在线 · 争议事件实时跟踪中</span>
          </p>
          <p className="hidden text-xs text-background-300 sm:block">第 214 期 · 2026.09.08 · 关键词持续收录</p>
        </div>
      </div>

      {/* 品牌 + 导航 */}
      <nav
        className={`transition-all duration-300 ${
          scrolled
            ? "border-b border-background-200/70 bg-background-50/95 backdrop-blur"
            : "bg-background-50"
        }`}
      >
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 md:px-6 md:py-4">
          <a href="#headline" className="flex items-center gap-3">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-eye-off-fill text-lg" />
            </span>
            <span className="leading-none">
              <span className="font-display text-2xl font-black tracking-tight text-foreground-950">吃瓜黑网</span>
              <span className="mt-1 block text-[10px] tracking-[0.3em] text-foreground-500">TUAGUA BLACKLIST MEDIA</span>
            </span>
          </a>

          <div className="hidden items-center gap-1 md:flex">
            {navLinks.map((l) => (
              <a
                key={l.id}
                href={`#${l.id}`}
                className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700"
              >
                {l.label}
              </a>
            ))}
            <span className="ml-2 flex items-center gap-2 whitespace-nowrap rounded-full border border-primary-200 bg-primary-50 px-3 py-1.5 text-xs font-medium text-primary-700">
              <i className="ri-flashlight-fill" />
              持续收录中
            </span>
          </div>

          <button
            type="button"
            aria-label="打开导航"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-200 bg-background-50 text-foreground-800 md:hidden"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`} />
          </button>
        </div>

        {open && (
          <div className="border-t border-background-200/70 bg-background-50 px-4 py-3 md:hidden">
            <div className="flex flex-col gap-1">
              {navLinks.map((l) => (
                <a
                  key={l.id}
                  href={`#${l.id}`}
                  onClick={() => setOpen(false)}
                  className="rounded-md px-3 py-2.5 text-sm text-foreground-800 hover:bg-background-100"
                >
                  {l.label}
                </a>
              ))}
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}